<template>
  <div>
    <el-main style="background-color: white;border-radius: 10px">
      <el-button type="primary" size="small" @click="openCategoryWindow">添加分类</el-button>
      <el-table
        ref="multipleTable"
        :data="categoryData"
        tooltip-effect="dark"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        @selection-change="handleSelectionChange"
        style="width: 100%">
        <el-table-column
          type="selection"
          width="80">
        </el-table-column>
        <el-table-column
          label="图片"
          width="150">
          <template slot-scope="scope">
            <img :src="scope.row.imagePath" width="60" height="60" style="border-radius: 50%">
          </template>
        </el-table-column>
        <el-table-column
          label="分类名称"
          width="250"
          prop="name">
        </el-table-column>
        <el-table-column
          label="博客数量"
          width="250"
          prop="count">
        </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button
              size="small"
              icon="el-icon-edit"
              @click="handleEdit(scope.$index, scope.row)">编辑
            </el-button>
            <el-button
              size="small"
              type="danger"
              icon="el-icon-delete"
              @click="handleDelete(scope.$index, scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :lock-scroll="false" :close-on-click-modal="false" :close-on-press-escape="false" title="修改分类"
                 centerp center
                 width="480px"
                 @close="cancel('categoryForm')"
                 :visible.sync="categoryFormVisible">
        <el-form :model="categoryForm" status-icon :rules="categoryRules" ref="categoryForm" label-width="100px"
                 class="demo-ruleForm"
                 style="margin-left: 20px;">
          <el-form-item label="头像 :" prop="imagePath">
            <el-upload
              v-model="categoryForm.imagePath"
              class="avatar-uploader"
              :action="uploadActionUrl+'/uploadImage'"
              name="image"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess">
              <img v-if="categoryForm.imagePath" :src="categoryForm.imagePath" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="分类名称 :" prop="name">
            <el-input v-model="categoryForm.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="submit('categoryForm')">确定</el-button>
            <el-button size="small" @click="cancel('categoryForm')">取消</el-button>
          </el-form-item>
        </el-form>

      </el-dialog>

      <el-dialog :lock-scroll="false" :close-on-click-modal="false" :close-on-press-escape="false" title="添加分类"
                 centerp center
                 width="480px"
                 @close="cancel('addCategoryForm')"
                 :visible.sync="addCategoryFormVisible">
        <el-form :model="addCategoryForm" status-icon :rules="addCategoryRules" ref="addCategoryForm"
                 label-width="100px"
                 class="demo-ruleForm"
                 style="margin-left: 20px;">
          <el-form-item label="头像 :" prop="imagePath">
            <el-upload
              v-model="addCategoryForm.imagePath"
              class="avatar-uploader"
              :action="uploadActionUrl+'/uploadImage'"
              name="image"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :on-success="addCategoryHandleAvatarSuccess">
              <img v-if="addCategoryForm.imagePath" :src="addCategoryForm.imagePath" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="分类名称 :" prop="name">
            <el-input v-model="addCategoryForm.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="addCategorySubmit('addCategoryForm')">确定</el-button>
            <el-button size="small" @click="addCategoryCancel('addCategoryForm')">取消</el-button>
          </el-form-item>
        </el-form>

      </el-dialog>

      <div style="margin-top: 20px">
        <el-button size="small" @click="deleteSelectUserList()">删除选中的记录</el-button>
      </div>
    </el-main>
  </div>
</template>

<script>
import request from "../../utils/axiosUtils";
import base_url from "../../utils/Constants";

export default {
  name: "CategoryManager",
  data() {
    return {
      adminInfo: {},
      categoryData: [
        {
          name: null,
          imagePath: null,
          count: null
        }
      ],
      categoryFormVisible: false,
      formLabelWidth: "100px",
      categoryForm: {
        id: null,
        imagePath: null,
        name: null
      },
      categoryRules: {
        imagePath: [
          {required: true, message: '头像不能为空', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '名称不能为空', trigger: 'blur'}
        ]
      },
      //多选框的内容
      selectCategoryList: [],
      //以下是添加分类的属性
      //表单是否可见
      addCategoryFormVisible: false,
      //form表单数据
      addCategoryForm: {
        imagePath: null,
        name: null
      },
      //rules属性
      addCategoryRules: {
        imagePath: [
          {required: true, message: '头像不能为空', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '名称不能为空', trigger: 'blur'}
        ]
      },
      //图片上传路径
      uploadActionUrl: base_url
    }
  },
  methods: {
    //处理头像之前
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else if (isPng) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
        return false;
      }
    },
    //处理头像成功
    handleAvatarSuccess(result) {
      if (result.flag) {
        this.categoryForm.imagePath = result.data;
      } else {
        this.$notify.error({
          title: '图片错误',
          duration: 6000,
          message: result.message
        });
      }
    },
    handleEdit(index, row) {
      this.categoryForm.id = row.id;
      this.categoryForm.imagePath = row.imagePath;
      this.categoryForm.name = row.name;
      this.categoryFormVisible = true;
    },
    //处理删除单个分类
    handleDelete(index, row) {
      this.$confirm('此操作将逻辑删除该分类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/blog/deleteCategoryById',
          method: 'post',
          params: {
            adminInfo: this.adminInfo,
            id: row.id
          }
        }).then(response => {
          if (response.data.flag) {
            this.getCategory();
            this.$notify({
              title: '分类',
              message: '删除成功',
              type: "success"
            })
          } else {
            this.$notify({
              title: '分类',
              message: '删除失败',
              type: "未知错误"
            })
          }
        }).catch(e=>{
          this.$notify({
            title: '分类',
            message: '删除失败',
            type: "网络错误"
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    //多选的回调
    handleSelectionChange(val) {
      this.selectCategoryList = val;
    },
    //编辑取消事件
    cancel(formName) {
      this.$refs[formName].resetFields();
      this.categoryFormVisible = false;
    },
    //编辑确定事件
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request({
            url: '/blog/updateCategory',
            method: 'post',
            params: {
              adminInfo: this.adminInfo,
              categoryInfo: this.categoryForm
            }
          }).then(response => {
            if (response.data.flag) {
              this.getCategory();
              this.categoryFormVisible = false;
            } else {
              this.$notify({
                title: '分类',
                message: '删除失败',
                type: "未知错误"
              })
            }
          })

        }
      })
    },
    //获取分类信息
    getCategory() {
      request({
        url: '/blog/getCategories',
        method: 'get'
      }).then(response => {
        let data = response.data.data;
        data.forEach(val => {
          val.imagePath = base_url + "/getImage/" + val.imagePath;
        })
        this.categoryData = data;
      })
    },
    //删除选中的记录
    deleteSelectUserList() {
      let categoryList = this.selectCategoryList;
      if (categoryList.length > 0) {
        this.$confirm('此操作将逻辑删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // console.log(categoryList);
          let selectCategoryIds = '';//选中的用户id数组
          let categoryListLength = categoryList.length;
          for (let i = 0; i < categoryListLength; i++) {
            if (i !== 0)
              selectCategoryIds += "&ids=" + categoryList[i].id;
            else
              selectCategoryIds += "ids=" + categoryList[i].id;
          }
          request({
            url: '/blog/deleteCategoryByIds?' + selectCategoryIds,
            method: 'post',
            params: {
              adminInfo: this.adminInfo,
            }
          }).then(response => {
            // console.log(response);
            if (response.data.flag) {
              this.getCategory();
              this.$message({
                type: 'success',
                message: "批量删除成功"
              });
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              });
            }
          }).catch(e=>{
            this.$notify({
              type: 'error',
              title: '分类',
              message: '网络错误!'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      } else {
        this.$notify({
          type: 'warning',
          message: "请选中要删除的项",
          duration: 1200,
          title: "提示"
        })
      }

    },
    //打开填写分类的窗口
    openCategoryWindow() {
      this.addCategoryFormVisible = true;
    },
    //添加分类头像处理完成
    addCategoryHandleAvatarSuccess(result) {
      if (result.flag) {
        this.addCategoryForm.imagePath = result.data;
      } else {
        this.$notify.error({
          title: '图片错误',
          duration: 6000,
          message: result.message
        });
      }
    },
    //分类提交事件
    addCategorySubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request({
            url: '/blog/addCategory',
            method: 'post',
            params: {
              categoryInfo: this.addCategoryForm,
              adminInfo: this.adminInfo
            }
          }).then(response => {
            if (response.data.flag) {
              this.addCategoryFormVisible = false;
              this.getCategory();
              this.$notify({
                title: '分类',
                message: '添加成功',
                duration: 2000,
                type: 'success'
              })
            } else {
              this.$notify({
                title: '分类',
                message: '未知错误',
                duration: 2000,
                type: 'error'
              })
            }
          })
        }
      })
    },
    //分类取消事件
    addCategoryCancel(formName) {
      this.$refs[formName].resetFields();
      this.addCategoryFormVisible = false;
    }
  },
  mounted() {
    let adminInfo = JSON.parse(window.sessionStorage.getItem("adminInfo"));
    this.adminInfo = adminInfo;
    this.getCategory();
  }
}
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/CategoryManager.vue